import React, { useEffect, useState } from 'react';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import NFTCard from '../../components/nftCard/NFTCard';
import banner from '../../assets/images/background/subheader-dark.jpg';
import Loader from '../../components/loader/Loader';

const Explore = () => {
    const [marketPlaceList, setMarketPlaceList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(true);
        axiosInstance
            .get(endpoints.getMarketNft)
            .then((res) => {
                setIsLoading(false);
                setMarketPlaceList(res.data.result);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
            });
    }, []);

    const searchHandler = () => {};

    if (isLoading) {
        return <Loader />;
    }
    return (
        <div className="no-bottom no-top" id="content">
            <div id="top"></div>
            <section id="subheader" className="text-light" style={{ backgroundImage: `url("${banner}")`, backgroundPosition: 'top' }}>
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1>Explore</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>
            <section aria-label="section">
                <div className="container">
                    {marketPlaceList?.length !== 0 ? (
                        <>
                            <div className="row mb-5">
                                <div className="col-6">
                                    <input
                                        id="quick_search"
                                        className="xs-hide w-100 ms-0"
                                        name="quick_search"
                                        placeholder="search item here..."
                                        type="text"
                                        style={{ color: 'white' }}
                                        onChange={searchHandler}
                                    />
                                </div>
                            </div>
                            <div className="row wow fadeIn">
                                {marketPlaceList?.map((item, index) => (
                                    <div className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12 nft-card-wrap" key={index}>
                                        <NFTCard data={item} />
                                    </div>
                                ))}
                                {/* <div className="col-md-12 text-center">
                            <Link to="/" id="loadmore" className="btn-main wow fadeInUp lead">
                                Load more
                            </Link>
                        </div> */}
                            </div>
                        </>
                    ) : (
                        <h3 className="text-center">No NFT found!!!</h3>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Explore;
